import { cleanChar } from '../utils/strings'

export function formatFqnForBigQuery(fqn: string) {
  return `\`${cleanChar(fqn, '`')}\``
}
